import React from 'react'
import "./Navbar.css";

function Navbar() {
  return (
    <div>
        <div className='fixed-top'>
              <div className="masterofsecuritysystem">
          <div className="album py-1">

            <div className="container">

              <div className="row ">

                <div className="col-md-6">
                  <div className="d-flex justify-content-between align-items-center">

                    <a style={{ color: "#ffffffff" }} className="bethuaclothshop me-5" href="tel: +91 9064797437"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-minus" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5" />
                      <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                    </svg><b> +91 9064797437</b></a>

                    <a style={{color:"white"}} href='review'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chat-square-text" viewBox="0 0 16 16">
  <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2.5a2 2 0 0 0-1.6.8L8 14.333 6.1 11.8a2 2 0 0 0-1.6-.8H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
  <path d="M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5M3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6m0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"/>
</svg> Write a Review ⭐</a>
                    
                  </div>
                </div>

                <div className="d-flex justify-content-between align-items-center">

                </div>
              </div>
            </div>
          </div>
        </div>
        <nav className="navbar navbar-expand-lg navbar-white bg-white shadow">
  <div className="container-fluid">
   
    <a style={{color:"#0a1555ff"}} className="navbar-brand " href="/"><b className='mss'>MASTER OF SECURITY SYSTEM</b></a>
   
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <a style={{color:"#0D47A1"}} className="nav-link active" aria-current="page" href="/">Home</a>
        </li>
        <li className="nav-item">
          <a style={{color:"#0D47A1"}} className="nav-link" href="Aboutus">About us</a>
        </li>
        <li className="nav-item">
          <a style={{color:"#0D47A1"}} className="nav-link" href="our-projects">Our Projects</a>
        </li>
        <li className="nav-item dropdown">
          <a style={{color:"#0D47A1"}} className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Services
          </a>
          <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
            <li><a className="dropdown-item" href="cctv_camera">CCTV Camera </a></li>
            <li><a className="dropdown-item" href="gps_system">GPS System</a></li>
        
            <li><a className="dropdown-item" href="intercom-system">Inetercom</a></li>
            <li><a className="dropdown-item" href="computer-care">Computer & Laptop</a></li>
            <li><a className="dropdown-item" href="sensor_system">Sensor System</a></li>
            <li><a className="dropdown-item" href="audio-video">Audio Video</a></li>
            <li><a className="dropdown-item" href="Electricservices">Electrical Service</a></li>
            <li><a className="dropdown-item" href="AllAccessories">All Accessories</a></li>
          </ul>
        </li>
            <li className="nav-item">
          <a style={{color:"#0D47A1"}} className="nav-link" href="product">Our Products</a>
        </li>
     <li className="nav-item">
          <a style={{color:"#0D47A1"}} className="nav-link" href="contactus">Contact us</a>
        </li>
      </ul>
     <a href='tel: 9064797437'>
        <button className="navcall" type="submit">+91 9064797437</button>
        </a>
     
    </div>
  </div>
</nav>
</div>
    </div>
  )
}

export default Navbar